<template>
  <div v-if="message"
       :class="['message-section message-partial', { active:activeMessage }, { ['js-has-word-highlight']:showBlacklistModal }]"
       :id="'message-' + message.id">
    <message
        :activeMessage="activeMessage"
        :campaignSendTime="sendTime"
        :isBudzAutoCampaign="isBudzAutoCampaign"
        isInView
        :messageModuleName="messageModuleName"
        :messagePriority="messagePriority"
        smsSend
        @update="updateMessage">
    </message>

    <text-notification-picker :selected="selectedNotificationTemplate" v-on:update:selected="updatedSelectedNotification" :templates="campaignNotificationTemplates" />

    <div class="data-description">
      <b>credit summary</b>

      <div>
        characters {{ characterCount }}
        <span v-if="totalCredits > 0">, credits {{ totalCredits }}</span>
      </div>
    </div>

    <p v-if="updateError" class="api-error">{{updateError}}</p>
  </div>
</template>

<script>
  import AxiosMixin from '../../mixins/AxiosMixin'
  import { isObject } from '../../utilities'
  import {mapGetters, mapState} from 'vuex'
  import Message from '../Message/'
  import MessageModule from '../../store/modules/message'
  import TextNotificationPicker from "../TextNotificationPicker";

  export default {
    props: {
      activeMessage: Boolean,
      autoCampaignId: [Number, String],
      isBudzAutoCampaign: Boolean,
      messageFromScope: Object,
      messageModuleName: String,
      messagePriority: Number,
      sendTime: String,
    },

    name: 'MessageEdit',

    components: {
      Message,
      TextNotificationPicker
    },


    mixins: [AxiosMixin],

    data() {
      return {
        message: null,
        modalConfig: null,
        updateError: null,
        selectedNotification: null
      }
    },

    methods: {
      afterMessageUpdate(data, keysUpdated) {
        const message = data?.message
        if (isObject(message)) {
          this.message = message
          this.updateCommunicationItems()
          this.toggleErrorMessage()
        } else {
          this.toggleErrorMessage(keysUpdated, null, true)
        }
      },

      configureErrorKeyword(keyUpdated) {
        switch (keyUpdated) {
          case '_type':
            return 'extension'
          case 'external_url':
            return 'url'
          case '_type_options':
            return 'target wallet'
        }
      },

      initMessageEdit() {
        this.message = this.messageFromScope
        this.$store.dispatch(`${this.messageModuleName}/UPDATE_MESSAGE_ID_TYPE`, {
          autoCampaignId: this.autoCampaignId,
          messageId: this.message.id,
          messageType: 'AutoCampaignMessage'
        })
        this.updateCommunicationItems()
        this.toggleEmptyMessage()
      },

      messageUpdateError(error, keysUpdated) {
        this.toggleErrorMessage(keysUpdated, error, true)
      },

      toggleEmptyMessage() {
        let isEmpty = this.mediaCredits < 1 && this.updatedSmsContent?.length < 1
        this.$emit('updateEmptyMessage', this.message.id, isEmpty)
      },

      toggleErrorMessage(keysUpdated, error, shouldAdd) {
        if (shouldAdd) {
          let keywords = []
          keysUpdated.forEach((key) => keywords.push(this.configureErrorKeyword(key)))
          keywords = keywords.join(', ')
          this.updateError = error ? `issue updating ${keywords}. ${error}` : `issue updating ${keywords}`
        } else {
          this.updateError = null
        }
      },

      updateCommunicationItems() {
        if (this.message) {
          this.$store.commit(`SET_SELECTED_NOTIFICATION_TEMPLATE`, {
            id: this.messageModuleName,
            templateId: this.message.template_id
          });

          this.$store.dispatch(`${this.messageModuleName}/UPDATE_COMMUNICATION_ITEMS`, {
            extensionType: this.message._type,
            externalUrl: this.message.external_url,
            mockUrl: this.message.mock_url,
            rewardId: this.message.reward_id,
            walletTarget: this.message._type_options
          })
          this.$store.dispatch(`${this.messageModuleName}/UPDATE_MESSAGE_STATE`, { stateKey: 'imageType', stateItem: this.message.image_type })
          this.$store.dispatch(`${this.messageModuleName}/UPDATE_SMS_CONTENT`, { smsContent: this.message.sms_content })
        }
      },

      updateMessage(dataToUpdate) {
        const params = { auto_campaign_message: dataToUpdate },
          url = `/api/v3/auto_campaign_messages/${this.message.id}?auto_campaign_id=${this.autoCampaignId}`,
          methodType = 'patch',
          onExtraParam = Object.keys(dataToUpdate)

        this.axiosMethod({methodType, url, params, onSuccess: this.afterMessageUpdate, onError: this.messageUpdateError, onExtraParam})
      },

      updatedSelectedNotification(newTemplate) {
        this.updateMessage({
          template_id: newTemplate.id
        });
      }
    },

    beforeCreate() {
      const moduleName = this.$options.propsData.messageModuleName
      if (!this.$store.hasModule(moduleName)) { this.$store.registerModule(moduleName, MessageModule) }
    },

    created() {
      this.initMessageEdit()
    },

    beforeDestroy() {
      if (this.$store.hasModule(this.messageModuleName)) { this.$store.unregisterModule(this.messageModuleName) }
    },

    computed: {
      ...mapState({
        hasBlacklistedWords (state) { return state[this.messageModuleName]?.hasBlacklistedWords },
        mediaCredits (state, getters) { return getters[`${this.messageModuleName}/mediaCredits`] },
        showBlacklistModal (state) { return state[this.messageModuleName]?.showBlacklistModal },
        updatedSmsContent (state) { return state[this.messageModuleName]?.updatedSmsContent },
        characterCount(state) { return state[this.messageModuleName]?.characterCount }
      }),

      totalCredits() { return this.$store.getters[`${this.messageModuleName}/totalCredits`] },
      selectedNotificationTemplate() { return this.$store.getters.selectedNotificationTemplateFor(this.messageModuleName) },
      ...mapState(['campaignNotificationTemplates']),
    },

    watch: {
      hasBlacklistedWords: function () {
        this.updateMessage({ has_blacklisted_words: this.hasBlacklistedWords })
      },

      isEmptyMessage: function () {
        this.toggleEmptyMessage()
      },
    }
  }
</script>
